import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { APPLICATION_SESSION } from '@core/services/auth/application-session';
import { isAuthenticatedApi } from '@core/services/auth/api-target';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const session = inject(APPLICATION_SESSION);
  if (
    !session.authenticated ||
    new URL(request.url, location.origin).pathname ===
      new URL(`${environment.API_URL}/public/parameters`, location.origin)
        .pathname ||
    !isAuthenticatedApi(
      request.url,
      [
        environment.API_URL,
        environment.CHAT_API,
        environment.NOTIFICATION_API,
        environment.PREDICTIVE_ANALYTICS_API_URL,
      ],
      location.origin,
    )
  ) {
    return next(request);
  }
  request = request.clone({ setHeaders: { 'ngsw-bypass': 'true' } });
  return from(session.accessToken()).pipe(
    switchMap((token) =>
      next(
        request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
      ).pipe(
        catchError((error: unknown) => {
          if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
            return throwError(() => error);
          }
          return from(session.accessToken(token)).pipe(
            switchMap((refreshed) =>
              next(
                request.clone({
                  setHeaders: { Authorization: `Bearer ${refreshed}` },
                }),
              ),
            ),
          );
        }),
      ),
    ),
  );
};
